<template>
  <div>
    <custom-actions title="物流统计">
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="plannedDate" label="统计日期">
          <el-date-picker v-model="dateArr" @change="changeDate" start-placeholder="开始时间" end-placeholder="结束时间"
            type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch('2')">查询</el-button>
          <el-button @click="onReset('searchForm2')">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="searchForm.ygType" @tab-click="handleTabClick">
        <el-tab-pane label="出库" name="A"></el-tab-pane>
        <el-tab-pane label="入库" name="B"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border :data="tableData">
        <el-table-column min-width="120" align="center" fixed="left" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" align="center" fixed="left" label="发货数量" prop="pickupQuantity"></el-table-column>
        <el-table-column min-width="120" align="center" fixed="left" label="到货数量" prop="arrivalQuantity"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'LogisticsTotal',
  mixins: [keepAlive],

  data() {
    return {
      activeName: '1',
      tableData: [],
      page: 1,
      total: 0,
      dateArr: [],
      searchForm: {
        ygType: 'A',
        startTime: '',
        endTime: ''
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasCancel() {
      return this.buttonList.includes('cancel')
    }
  },
  created() {
    this.dateArr = [this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD'), this.$dayjs().format('YYYY-MM-DD')]
    this.searchForm = {
      ygType: 'A',
      startTime: this.dateArr[0],
      endTime: this.dateArr[1]
    }
    this.loadData()
  },
  methods: {
    handleTabClick(tab) {
      this.loadData()
    },
    changeDate(date) {
      if (date && date.length) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleInfoCount, {
        ...this.searchForm
      }).then(res => {
        this.tableData = res
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.tableData = []
      this.loadData()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-view {
  color: #0e6ad7;
  text-decoration: underline;
  cursor: pointer;
}
</style>
